import React from 'react';
import {
  GridColumnMenuContainer,
  GridColumnMenuProps,
  GridColumnMenuSortItem,
  GridColumnMenuFilterItem,
} from '@mui/x-data-grid';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  VisibilityOff as HideIcon,
  ViewWeek as ManageColumnsIcon,
  Add as AddColumnIcon,
} from '@mui/icons-material';

export interface LeadColumnMenuProps extends GridColumnMenuProps {
  onHideColumn?: (colKey: string) => void;
  onOpenManageColumns?: (initialTab: number) => void;
}

export function getColumnBackendKey(colDef: any): string {
  return colDef?.colKey || colDef?.field || '';
}

export const LeadColumnMenu: React.FC<LeadColumnMenuProps> = (props) => {
  const { hideMenu, colDef, onHideColumn, onOpenManageColumns } = props;

  const colKey = getColumnBackendKey(colDef);

  const handleHideColumn = async (e: React.MouseEvent) => {
    e.stopPropagation();
    hideMenu(e);
    if (onHideColumn && colKey) {
      await onHideColumn(colKey);
    }
  };

  const handleManageColumns = (e: React.MouseEvent) => {
    e.stopPropagation();
    hideMenu(e);
    if (onOpenManageColumns) {
      onOpenManageColumns(0);
    }
  };

  const handleAddColumn = (e: React.MouseEvent) => {
    e.stopPropagation();
    hideMenu(e);
    if (onOpenManageColumns) {
      onOpenManageColumns(1);
    }
  };

  return (
    <GridColumnMenuContainer {...props}>
      <GridColumnMenuSortItem colDef={colDef} onClick={hideMenu} />
      <GridColumnMenuFilterItem colDef={colDef} onClick={hideMenu} />
      <MenuItem onClick={handleHideColumn}>
        <ListItemIcon>
          <HideIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Hide column</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleManageColumns}>
        <ListItemIcon>
          <ManageColumnsIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Manage columns</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleAddColumn}>
        <ListItemIcon>
          <AddColumnIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Add column</ListItemText>
      </MenuItem>
    </GridColumnMenuContainer>
  );
};
